module.exports = function getResource(label, vars = []) {
    let resources = {
        noShippingAddressRequired: 'No shipping address or payment is required for this order. Please review your information before placing your order.',
        noPaymentRequired: 'No payment is required for this order. Please review your information before placing your order.',
        pleaseReviewOrder: `Please review your order information before ${vars[0]}`,
        pleaseReviewOrderTotal: 'Please review your order information before placing your order. Your Order Total is the complete amount you will be billed. It includes all duty, taxes, and shipping costs.',
        byPlacingOrderText: 'By placing your order, you agree to the ',
        termsConditions: 'Terms & Conditions',
        andText: ' and ',
        privacyPolicy: 'Privacy Policy',
        ofText: ' of ',
        borderFreeAddress: ', Sephora’s international fulfillment service. Borderfree is an online merchant that is located at 292 Madison Avenue, 5th Floor, New York, NY, 10017, US.',
        pleaseReviewOrderInfoText: 'Please review your order information before placing your order.',
        byPlacingOrderCaText: 'By placing your order, you agree to be bound by the ',
        termsOfPurchase: 'Terms of Purchase',
        termsOfUse: 'Terms of Use'
    };
    return resources[label];
};
